import { Box, Stack, Typography } from '@mui/material';
import React from 'react'

interface Props{
    id: string;
    selected: boolean;
    onClick: () => void;
    title: string;
    icon: React.ReactNode;
}
export const SidebarNavItem = ({ id, selected, onClick, title, icon }: Props) => {
  return (
    <Box key={id} sx={{ px: 2, py: 0.5 }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: '0.5rem 0.5rem',
        borderRadius: 2,
        backgroundColor: selected ? 'grey.300' : 'transparent',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: selected ? 'grey.100' : 'grey.50',
        },
      }}
      onClick={onClick}
    >
      <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0 }}>
        {icon}
        <Typography
          variant="body2"
          noWrap
          sx={{
            fontWeight: 400,
            fontSize: '0.875rem',
            textTransform: 'capitalize',
          }}
        >
          {title}
        </Typography>
      </Stack>

      
    </Box>
  </Box>
  )
}